// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__TrtGN","text":"styles_text__2Osmt","line":"styles_line__eoY5z"};